webpackJsonp([135314181134312],{

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(13);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ItemNews = __webpack_require__(99);
	
	var _ItemNews2 = _interopRequireDefault(_ItemNews);
	
	var _LinkTagTopic = __webpack_require__(75);
	
	var _LinkTagTopic2 = _interopRequireDefault(_LinkTagTopic);
	
	var _FillBg = __webpack_require__(16);
	
	var _FillBg2 = _interopRequireDefault(_FillBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Base = /*#__PURE__*/(0, _reactEmotion2.default)(_Container2.default, {
	  target: 'eog8fzg0'
	})('padding-left:3rem;padding-right:3rem;');
	
	var Team = function Team(_ref) {
	  var team = _ref.pathContext.team,
	      _ref$data$allMarkdown = _ref.data.allMarkdownRemark,
	      edges = _ref$data$allMarkdown.edges,
	      totalCount = _ref$data$allMarkdown.totalCount;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: '@' + team + ' | ' + _website2.default.siteTitle }),
	    _react2.default.createElement(
	      _Header2.default,
	      { slim: true, title: '@' + team },
	      totalCount,
	      ' ',
	      totalCount === 1 ? 'Post' : 'Posts',
	      totalCount === 1 ? '' : '',
	      _react2.default.createElement('br', null)
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _FillBg2.default,
	        null,
	        _react2.default.createElement(_LinkTagTopic2.default, null),
	        _react2.default.createElement(
	          Base,
	          null,
	          _react2.default.createElement('br', null),
	          edges.map(function (edge, index) {
	            return _react2.default.createElement(_ItemNews2.default, {
	              key: edge.node.frontmatter.title,
	              title: edge.node.frontmatter.title,
	              path: edge.node.fields.slug,
	              date: edge.node.frontmatter.date,
	              tags: edge.node.frontmatter.tags,
	              topic: edge.node.frontmatter.topic,
	              teams: edge.node.frontmatter.teams,
	              timeToRead: edge.node.timeToRead,
	              excerpt: edge.node.excerpt,
	              data: index,
	              cover: edge.node.frontmatter.cover
	            });
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = Team;
	
	
	Team.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    team: _propTypes2.default.string.isRequired
	  }),
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array.isRequired
	    })
	  })
	};
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-team-jsx-42a96b50688337c02c47.js